import { render, staticRenderFns } from "./Breads.vue?vue&type=template&id=52cc8be7&scoped=true&"
var script = {}
import style0 from "./Breads.vue?vue&type=style&index=0&id=52cc8be7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc8be7",
  null
  
)

export default component.exports